import { Grid, Modal } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  Button,
  TextField,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';

import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React from 'react';
import componentConstants from '../../../core-utils/messages/componentConstants';
import ReportCreateNewLabelField from '../../atoms/ReportCreateNewLabelField';
import Dropdown from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Dropdown';
import { commonDropDownProps } from '../../atoms/ReportsCohortItem';

export const cellStyles4 = {
  color: patientAccessTheme.palette.text.mediumemphasis,
  fontSize: '14px',
  fontWeight: 400,
};

export interface AddNewMemberModalProps {
  open: boolean;
  handleClose: () => any;
  handleSave: () => any;
  isSaveButtonDisabled: boolean;
  assignCareNavState: [any, React.Dispatch<React.SetStateAction<any>>];
}

const AddNewMemberModal: React.FC<AddNewMemberModalProps> = ({
  open,
  handleClose,
  handleSave,
  isSaveButtonDisabled,
  assignCareNavState,
}) => {
  const useStyles = makeStyles()({
    modal: {
      width: '553px',
      height: '480px',
      background: patientAccessTheme.palette.status.white,
      borderRadius: '8px',
      padding: '24px 24px 24px 24px',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      flexDirection: 'column',
    },
    inputFieldsGrid: {
      width: '505px',
      marginTop: '20px',
      background: '#FBFBFE',
      padding: '24px 24px 14px 24px',
      borderRadius: '8px',
    },
    selectFields: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: '10px',
    },
    cancelButton: {
      padding: '9px 16px',
      width: '102px',
      height: '36px',
      border: '1px solid ' + patientAccessTheme.palette.primary[500],
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
    },
    saveButton: {
      padding: '9px 16px',
      width: '102px',
      height: '36px',
      border:
        '1px solid ' + isSaveButtonDisabled
          ? patientAccessTheme.palette.grey[500]
          : patientAccessTheme.palette.primary[500],
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
    },
  });
  const { classes } = useStyles();
  const constants = componentConstants.ORGANISMS.CARE_NAV_MODALS.ADD_MEMBER;

  const [assignData, setAssignData] = assignCareNavState;

  return (
    <Modal open={open} onClose={handleClose}>
      <Grid container className={classes.modal}>
        <Grid>
          <Typography
            fontSize="18px"
            lineHeight="26px"
            fontType="semibold"
            textColor={patientAccessTheme.palette.text.highemphasis}
            margin="4px 0px 0px 0px"
          >
            {constants.TITLE}
          </Typography>
          <Typography
            fontSize="14px"
            lineHeight="24px"
            fontType="normal"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
            margin="4px 0px 5px 0px"
          >
            {constants.SUB_TITLE}
          </Typography>
        </Grid>

        <Grid container className={classes.inputFieldsGrid}>
          <Grid className={classes.selectFields}>
            <Grid style={{ marginRight: '30px' }}>
              <ReportCreateNewLabelField
                label={constants.NAME}
                required
                component={
                  <TextField
                    value={assignData.name}
                    error={false}
                    placeholder={'yyyy zzzz'}
                    height="36px"
                    width="213px"
                    inputPropsStyle={{
                      padding: '16px',
                    }}
                    onChange={(e: any) => {
                      setAssignData((prev: any) => ({
                        ...prev,
                        name: e.target.value,
                      }));
                    }}
                  />
                }
              />
            </Grid>
            <Grid>
              <ReportCreateNewLabelField
                label={constants.AGE}
                required
                component={
                  <TextField
                    value={assignData.age}
                    type="number"
                    error={false}
                    placeholder={'age'}
                    height="36px"
                    width="213px"
                    inputPropsStyle={{
                      padding: '16px',
                    }}
                    onChange={(e: any) => {
                      setAssignData((prev: any) => ({
                        ...prev,
                        age: e.target.value,
                      }));
                    }}
                  />
                }
              />
            </Grid>
          </Grid>

          <Grid className={classes.selectFields}>
            <Grid style={{ marginRight: '30px' }}>
              <ReportCreateNewLabelField
                label={constants.GENDER}
                required
                component={
                  <Dropdown
                    label={'Select'}
                    dropDownOptions={['Male', 'Female']}
                    dropDownValues={['Male', 'Female']}
                    value={assignData.gender}
                    setValue={null}
                    handleChange={(e) => {
                      setAssignData((prev: any) => ({
                        ...prev,
                        gender: e.target.value,
                      }));
                    }}
                    selectStyles={{
                      ...commonDropDownProps.selectStyles,
                      width: '213px',
                    }}
                    labelTop="10px"
                  />
                }
              />
            </Grid>
            <Grid>
              <ReportCreateNewLabelField
                label={constants.ENROLLMENT}
                required
                component={
                  <Dropdown
                    label={'Select'}
                    dropDownOptions={['Enrolled', 'Not Enrolled']}
                    dropDownValues={['Enrolled', 'Not Enrolled']}
                    value={assignData.enroll_status}
                    setValue={null}
                    handleChange={(e) => {
                      setAssignData((prev: any) => ({
                        ...prev,
                        enroll_status: e.target.value,
                      }));
                    }}
                    selectStyles={{
                      ...commonDropDownProps.selectStyles,
                      width: '213px',
                    }}
                    labelTop="10px"
                  />
                }
              />
            </Grid>
          </Grid>

          <Grid className={classes.selectFields}>
            <Grid>
              <ReportCreateNewLabelField
                label={constants.CONDITION}
                component={
                  <TextField
                    value={assignData.condition}
                    error={false}
                    placeholder={'condition'}
                    height="36px"
                    width="453px"
                    inputPropsStyle={{
                      padding: '16px',
                    }}
                    onChange={(e: any) => {
                      setAssignData((prev: any) => ({
                        ...prev,
                        condition: e.target.value,
                      }));
                    }}
                  />
                }
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          style={{
            position: 'absolute',
            bottom: 0,
            margin: '0px 0px 24px 240px',
          }}
          sx={{
            alignItems: 'center',
          }}
        >
          <Grid style={{ marginRight: '12px' }}>
            <Button
              label={constants.CANCEL}
              variant="outlined"
              className={classes.cancelButton}
              onClick={handleClose}
            />
          </Grid>
          <Grid>
            <Button
              label={constants.SUBMIT}
              variant="contained"
              className={classes.saveButton}
              disabled={isSaveButtonDisabled}
              onClick={() => {
                handleSave && handleSave();
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};
export default AddNewMemberModal;
